import React from 'react'
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,

} from "@mui/material";
import instance from '../../Utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Designstatus = ({ statusDialog, setstatusDialog, selectedDesign, selectedSubDesign, mode, setgetdesign, setgetdesignsub }) => {

    const handleClose = () => {
        setstatusDialog(false);
    }
    //handledesigntypeStatus
    const handledesignStatus = async () => {
        try {
            const response = await instance.patch(`/Catalogue/toggleDesignType?_id=${selectedDesign.designId}`)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetdesign(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }

    //handledesignsubStatus
    const handledesignsubStatus = async () => {
        try {
            const response = await instance.patch(`/Catalogue/toggleDesign?_id=${selectedSubDesign.designsubId}`)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetdesignsub(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message); // Handle errors
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={statusDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    update status
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <>
                        {mode === "Design Type" ?
                            (
                                <React.Fragment>
                                    <BootstrapDialog
                                        onClose={handleClose}
                                        aria-labelledby="customized-dialog-title"
                                        open={statusDialog}
                                        className="admin-admins"
                                    >
                                        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                            Update Status
                                        </DialogTitle>
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleClose}
                                            sx={{
                                                position: "absolute",
                                                right: 8,
                                                top: 8,
                                                color: (theme) => theme.palette.grey[500],
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <DialogContent dividers>
                                            <Typography>
                                                Are you sure you want to update the status of <strong>{selectedDesign?.designtype} </strong>?
                                            </Typography>
                                        </DialogContent>
                                        <DialogActions >
                                            <Button className="cancel-btn" onClick={handleClose}>Cancel</Button>
                                            <Button className="add-btn" onClick={handledesignStatus}>Confirm</Button>
                                        </DialogActions>
                                    </BootstrapDialog>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <BootstrapDialog
                                        onClose={handleClose}
                                        aria-labelledby="customized-dialog-title"
                                        open={statusDialog}
                                        className="admin-admins"
                                    >
                                        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                                            Update Status
                                        </DialogTitle>
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleClose}
                                            sx={{
                                                position: "absolute",
                                                right: 8,
                                                top: 8,
                                                color: (theme) => theme.palette.grey[500],
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <DialogContent dividers>
                                            <Typography>
                                                Are you sure you want to update the status of <strong>{selectedSubDesign?.name} </strong>?
                                            </Typography>
                                        </DialogContent>
                                        <DialogActions >
                                            <Button className="cancel-btn" onClick={handleClose}>Cancel</Button>
                                            <Button className="add-btn" onClick={handledesignsubStatus}>Confirm</Button>
                                        </DialogActions>
                                    </BootstrapDialog>
                                </React.Fragment>
                            )
                        }
                    </>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Designstatus